import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useItems } from '../contexts/ItemsContext';
import { useUser } from '../contexts/UserContext';
import './ItemDetail.css';

const ItemDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getItemById } = useItems();
  const { user, addToCart, addFavorite, removeFavorite } = useUser();

  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    const loadItem = async () => {
      try {
        setLoading(true);
        // For now, we'll get the item from the items context
        // In a real app, you might want to fetch individual item details
        const itemData = getItemById(id);
        if (itemData) {
          setItem(itemData);
        } else {
          setError('למה זה לא עובד? לא ברור');
        }
      } catch (err) {
          setError('למה זה לא עובד? לא ברור');
        console.error('Error loading item:', err);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      loadItem();
    }
  }, [id, getItemById]);

  const handleAddToCart = async () => {
    if (!user) {
      // Handle not logged in user
      return;
    }

    try {
      await addToCart(item);
      setShowSuccessMessage(true);
      setTimeout(() => setShowSuccessMessage(false), 3000);
    } catch (err) {
      console.error('Error adding to cart:', err);
    }
  };

  const isItemFavorite = () => {
    if (!user?.likes) return false;
    return user.likes.some(like => like.id === item.id);
  };

  const toggleFavorite = async () => {
    if (!user) return;

    try {
      if (isItemFavorite()) {
        await removeFavorite(item.id);
      } else {
        await addFavorite(item);
      }
    } catch (err) {
      console.error('Error toggling favorite:', err);
    }
  };

  const getItemImages = () => {
    if (!item?.files) return [];
    return item.files.filter(file => file.type === 'image');
  };

  if (loading) {
    return (
      <div className="item-detail-container">
        <div className="item-detail-loading">טוען מוצר...</div>
      </div>
    );
  }

  if (error || !item) {
    return (
      <div className="item-detail-container">
        <div className="item-detail-error">
          <h2>שגיאה</h2>
          <p>{'למה זה לא עובד? לא ברור'}</p>
          <button onClick={() => navigate(-1)} className="back-btn">
            מכאן חוזרים
          </button>
        </div>
      </div>
    );
  }

  const images = getItemImages();
  const mainImage = images[selectedImageIndex] || images[0];

  return (
    <div className='out-container'>
    <div className="item-detail-container">
      <div className="item-detail-header">
        <button onClick={() => navigate(-1)} className="back-btn">
          ← מכאן חוזרים
        </button>
      </div>

      <div className="item-detail-content">
        {/* Centered details */}
        <div className="item-detail-info" style={{ alignItems: 'flex-end' }}>
          <div className="item-detail-description" style={{ width: '80%', textAlign: 'right', alignItems: 'flex-end' }}>
            <div className='title-row' style={{ justifyContent: 'flex-end' }}>
              {item.video && (
                <div className="item-detail-row">
                  <svg width="26" height="26" viewBox="0 0 24 24" fill="none"
                    stroke="#0cad5e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                    xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" />
                    <polygon points="10,8 16,12 10,16" />
                  </svg>
                </div>
              )}
              <h1 className="item-title-large">{item.name}</h1>
            </div>
            {item.description && (
              <div className="item-description-small">
                <p>{item.description}</p>
              </div>
            )}
            <div className="item-details-list">
              <div className="item-detail-row">
                <strong></strong>₪ {item.price}
              </div>
              <div className="item-detail-row">
                <strong></strong> {item.much_for}
              </div>
              {/* {item.features && item.features.length > 0 && (
                <div className="item-detail-row">
                  <strong>תכונות:</strong>
                  <div className="features-list">
                    {item.features.map(feature => (
                      <span key={feature.id} className="feature-tag">
                        {feature.name}
                      </span>
                    ))}
                  </div>
                </div>
              )} */}
            </div>
            <div className="item-detail-actions">
              <div className="action-buttons-row" style={{ flexDirection: 'row-reverse', justifyContent: 'flex-end', gap: '15px' }}>
                <button
                  className="add-to-cart-btn-flat"
                  onClick={handleAddToCart}
                  disabled={!user}
                  style={{ borderRadius: 0 }}
                >
                  הוסף לסל 
                </button>
                                {user && (
                  <button
                    className={`favorite-btn-flat ${isItemFavorite() ? 'active' : ''}`}
                    onClick={toggleFavorite}
                    style={{
                      border: '2px solid #e53935',
                      background: isItemFavorite() ? '#e53935' : '#fff',
                      color: isItemFavorite() ? '#fff' : '#e53935',
                      borderRadius: 0,
                    }}
                  >
                    !אהבתי
                  </button>
                )}
              </div>
            </div>
          </div>
          {showSuccessMessage && (
            <div className="success-message">
              ✓ איזה כיף, המוצר נוסף לסל בהצלחה!
            </div>
          )}
        </div>
        {/* Right side - Images */}
        <div className="item-detail-images">
          <div className="item-detail-main-image">
            {mainImage ? (
              <img src={mainImage.url} alt={item.name} className='main-img'/>
            ) : (
              <div className="item-detail-no-image">למה אין תמונה?</div>
            )}
          </div>
          {images.length > 1 && (
            <div className="item-detail-thumbnails">
              {images.map((image, index) => (
                <button
                  key={image.id || index}
                  className={`thumbnail ${selectedImageIndex === index ? 'active' : ''}`}
                  onClick={() => setSelectedImageIndex(index)}
                >
                  <img src={image.url} alt={`${item.name} ${index + 1}`} />
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Bottom section - Recommendations */}
      <div className="item-recommendations">
        <h3>המלצות עלי :)</h3>
        <div className="recommendations-placeholder">
          <p>  המלצות עלי עדיין בדרך...אולי עוד תספיקי להיות הראשונה שממליצה עלי</p>
          <p></p>
        </div>
      </div>
    </div>
  </div>
  );
};

export default ItemDetail;
